import {
  FIELD_REQUIRED,
  GENERIC_ERROR,
  INVALID_EMAIL_ADDRESS,
  LENGTH_MAX,
  LENGTH_MIN,
} from "../../constants/errors";

import type { LocaleObject } from "yup/lib/locale";

export const yupLocale: LocaleObject = {
  mixed: {
    default: GENERIC_ERROR,
    required: FIELD_REQUIRED,
  },
  string: {
    min: ({ min }: { min: number }) => ({
      key: LENGTH_MIN,
      values: { $minLength: min },
    }),
    max: ({ max }: { max: number }) => ({
      key: LENGTH_MAX,
      values: { $maxLength: max },
    }),
    email: INVALID_EMAIL_ADDRESS,
  },
};
